export enum HttpStatusCode {
    OK = 200,
    Redirect = 302,
    BadRequest = 400,
    Unauthorized = 401,
    Forbidden = 403,
    NotFound = 404,
    InternalServerError = 500,
    TemporarilyDisabled = 540
}